import { FormatterMoney } from "components/Function";

const Total = ({ data }) => {
    return (
        <>
            <div className="nav nav-pills d-flex justify-content-evenly nav-pills-custom mb-6 mt-6 row" role="tablist">
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Total GMV</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-wallet fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block"><FormatterMoney money={data?.revenue || 0} /></span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Total Customers</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-people fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.uniqueCustomers || 0}</span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Total Orders/ Items</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-purchase fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.orderCount || 0} / {data?.totalItems || 0}</span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Total Canceled</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-cross-circle fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.orderCancelCount || 0}</span>
                        </div>
                    </span>
                </div>
            </div>
            <div className="nav nav-pills d-flex justify-content-between nav-pills-custom mb-6 mt-6 row" role="tablist">
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Est. Earn</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-finance-calculator fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">
                                <FormatterMoney money={data?.profits || 0} />
                            </span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">
                            Fulfill Fee
                        </span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-printer fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block"><FormatterMoney money={data?.baseCost || 0} /></span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">
                            Est. Receive
                        </span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-bank fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block"><FormatterMoney money={(data?.profits - data?.baseCost).toFixed(2) || 0} /></span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">
                            Est. Fees Shipping
                        </span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-courier-express fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block"><FormatterMoney money={data?.totalShipping} /></span>
                        </div>
                    </span>
                </div>
            </div>
            <div className="nav nav-pills d-flex justify-content-evenly nav-pills-custom mb-6 mt-6 row" role="tablist">
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >

                        <span className="text-gray-800 fw-semibold fs-7 ">Seller-fault cancellation rate</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-arrow-circle-left fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.sellerFaultCancelRate}% {+data?.sellerFaultCancelRate > 2.5 && +data?.sellerFaultCancelRate !== 0 ? "- Danger" : ""}</span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">Late-dispatch rate</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-delivery-time fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.lateDispatchRate}% {+data?.lateDispatchRate > 4 && +data?.lateDispatchRate !== 0 ? "- Danger" : ""}</span>
                        </div>
                    </span>
                </div>
                <div className=" me-0 col-md-2" role="presentation">
                    <span
                        className="nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-danger flex-column flex-stack pt-3 pb-3 page-bg show w-100 shadow rounded-pill"
                        role="button"
                        style={{ height: 130 }}
                    >
                        <span className="text-gray-800 fw-semibold fs-7 ">On-time Delivery Rate</span>
                        <div className="nav-icon">
                            <span className="symbol-label">
                                <i className="ki-outline ki-delivery-geolocation fs-4qx fw-semibold"></i>
                            </span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 fw-bold d-block">{data?.onTimeDeliveryRate}% {+data?.onTimeDeliveryRate < 90 && +data?.onTimeDeliveryRate !== 0 ? "- Danger" : ""}</span>
                        </div>
                    </span>
                </div>
            </div>
        </>
    );
};

export default Total;
